import update from 'immutability-helper';
import R from 'ramda';

import {
  SET_ORDERS, ADD_ORDER, TOGGLE_COMPLETE_ORDER, UPDATE_ORDER, REMOVE_ORDER,
} from '_store/actions/orders';

import { LOGOUT_USER } from '_store/actions/user';

export function order(state = {
  completed: false,
}, action) {
  switch (action.type) {
    case ADD_ORDER:
      return update(state, {
        id: { $set: action.id },
        text: { $set: action.text },
        createdAt: { $set: action.createdAt },
      });
    case TOGGLE_COMPLETE_ORDER:
      return update(state, {
        completed: { $apply: x => !x },
      });
    case UPDATE_ORDER:
      return update(state, {
        text: { $set: action.text },
        updatedAt: { $set: action.updatedAt },
      });
    default:
      return state;
  }
}

export default function orders(state = [], action) {
  const index = R.findIndex(R.propEq('id', action.id), state);
  const updatedAtIndex = { $splice: [[index, 1, order(state[index], action)]] };

  switch (action.type) {
    case SET_ORDERS:
      return update(state, { $set: action.orders });
    case ADD_ORDER:
      return update(state, { $push: [order(undefined, action)] });
    case TOGGLE_COMPLETE_ORDER:
      return update(state, updatedAtIndex);
    case UPDATE_ORDER:
      return update(state, updatedAtIndex);
    case REMOVE_ORDER:
      return update(state, { $splice: [[index, 1]] });
    case LOGOUT_USER:
      return [];
    default:
      return state;
  }
}
